import { RouteDefinition } from "../../../routes";
import { IfDoEditScreen } from "./ifdoEditScreen";

export const IftttSettingsRoutes: RouteDefinition[] = [
  {
    routerLink: "/settings/third-party",
    component: IfDoEditScreen,
  },
];
